export default {
  SAVE: 'save',
  DRAFTED: 'drafted',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled'
}
